import { render, staticRenderFns } from "./BIMConsole.vue?vue&type=template&id=7352447c&scoped=true"
import script from "./BIMConsole.vue?vue&type=script&lang=js"
export * from "./BIMConsole.vue?vue&type=script&lang=js"
import style0 from "./BIMConsole.vue?vue&type=style&index=0&id=7352447c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7352447c",
  null
  
)

export default component.exports